module.exports = __webpack_public_path__ + "public/img/junyao_qr.1121a39a.jpeg";